//----- Component --------------------------------------------------------/
// Developer :  Daiana Curcio
// Creation Date : 11/11/2024
// Version : 1
// Description : Es el Tab para la pantalla de instalaciones granel.
//
//------Changes --------------------------------------------------------------------- -------------//
// Change Date :
// Change by :
// Change description:
//
// Change Date :
// Change by :
// Change description:
//========================================================================/

import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Navbar from "../../../Navbar";
import Instalaciones2 from "./Instalaciones2";
import { logEventos } from "../../../../services/services";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  useEffect(() => {
    logEventos(
      "Acceso al menú Instalaciones Granel",
      "Instalaciones Granel",
      "Ver las instalaciones,motivos de instalación y desconexión",
      localStorage.getItem("user")
    );
  }, []);

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function Tab_instalaciones() {
  const [activeTab, setActiveTab] = useState(0);
  const [showTabs, setShowTabs] = useState(true);

  return (
    <div>
      <Navbar />
      {showTabs ? (
        <Box sx={{ borderBottom: 1, borderColor: "divider", marginTop: 1 }}>
          <Tabs
            value={activeTab}
            onChange={(event, newValue) => setActiveTab(newValue)}
            aria-label="basic tabs example"
            centered
            variant="fullWidth"
          >
            <Tab label="Movimientos grua" {...a11yProps(0)} />
            <Tab label="Instalaciones" {...a11yProps(1)} />
            <Tab label="Reemplazo" {...a11yProps(2)} />
          </Tabs>
        </Box>
      ) : null}
      <Instalaciones2 activeTab={activeTab} setShowTabs={setShowTabs} />
    </div>
  );
}
